import { useState } from 'react';

interface Props {
  ageHours: number | null;
  stagedAt: string | null;
}

export function FreshnessBanner({ ageHours, stagedAt }: Props) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  const hours = ageHours == null ? null : Math.round(ageHours);
  const stagedLabel = stagedAt ? new Date(stagedAt).toLocaleString() : 'unknown';

  return (
    <div
      className="border rounded-md px-4 py-2.5 flex items-start justify-between mb-3"
      style={{ background: '#FFF3E8', borderColor: '#F4C998', color: '#E07B39' }}
    >
      <div className="text-sm">
        <span className="font-medium">⚠ Data may be stale —</span>{' '}
        last warehouse sync was {hours != null ? `${hours} hours ago` : 'over 36 hours ago'} ({stagedLabel}).
        The daily pipeline may have failed. Contact IT if this persists.
      </div>
      <button
        className="ml-3 text-xs text-text-muted hover:text-text-secondary shrink-0"
        onClick={() => setDismissed(true)}
      >
        Dismiss
      </button>
    </div>
  );
}
